import { useDispatch, useSelector } from "react-redux";
import { handleCheckBox, handleQuestionMarks } from "../redux/editorSlice";
import { handleSubmit } from "../redux/slice";
import { useState } from "react";

function Checkbox({ data, id }) {
  const dispatch = useDispatch();

  const { questions } = useSelector((store) => store.createPaperEditor);
  const { isJoyRideRunning } = useSelector(
    (store) => store.createQstnPaper
  );

  // 🔹 Local popup state
const [showPopup, setShowPopup] = useState(false);
const [popupShown, setPopupShown] = useState(false);
const [pendingCheck, setPendingCheck] = useState(null);

  const isChecked = !!questions.find(
    (q) => q.question_id === data.question_id
  );

 const handleOnChange = (e) => {
  const value = e.target.checked;

  // 🎯 FIRST selection during Joyride → SHOW POPUP FIRST
  if (
    value &&
    !isChecked &&
    isJoyRideRunning &&
    !popupShown &&
    questions.length <=1
  ) {
    setPendingCheck(value); // ⏸️ store action
    setShowPopup(true);
    setPopupShown(true);
    return; // 🚫 STOP here (do NOT dispatch yet)
  }

  // ✅ Normal flow
  dispatch(handleCheckBox({ type: value, data }));
  dispatch(handleSubmit(false));
};

const handlePopupOk = () => {
  if (pendingCheck !== null) {
    dispatch(handleCheckBox({ type: pendingCheck, data }));
    dispatch(handleSubmit(false));
    setPendingCheck(null);
  }

  setShowPopup(false);
};


  return (
    <>
      {/* Checkbox */}
      <div className="d-flex gap-3 align-items-center">
        <input
          type="checkbox"
          id={id}
          checked={isChecked}
          onChange={handleOnChange}
        />
      </div>

      {/* Popup */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            zIndex: 11000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px 24px",
              borderRadius: "10px",
              width: "420px",
              textAlign: "center",
            }}
          >
            <p style={{ fontSize: "16px", marginBottom: "20px" }}>
              You can select the required number of questions from a single
              chapter or multiple chapters.

              <br/>
              <span style={{marginTop:"10px"}}>आप आवश्यक संख्या में प्रश्न एक ही अध्याय से या एक से अधिक अध्यायों से चुन सकते हैं।</span>
            </p>
            

            <button
              className="btn btn-primary"
              onClick={handlePopupOk}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
}
// Multiple Choice Single Correct
export function DisplayQstnType1({ question, id }) {
  return (
    <div className="border rounded p-2 mt-2">
      <div className="d-flex gap-3">
        <Checkbox id={id} data={question} />
        <label
          className="custom-label-qstn"
          // htmlFor={id}
        >
          Q. {question.question_text}
        </label>
      </div>
      <div className="mx-4">
        <label>Options</label>
        {/* <br /> */}
        <ol type="a">
          {question.options.map((o, i) => (
            <li key={i + 1}>{o.text}</li>
          ))}
        </ol>
      </div>
    </div>
  );
}

// True or False
export function DisplayQstnType3({ question, id }) {
  return (
    <div className="border rounded p-2 mt-2">
      <div className="d-flex gap-3">
        <Checkbox id={id} data={question} />
        <label
          className="custom-label-qstn"
          // htmlFor={id}
        >
          Q. {question.question_text}
        </label>
      </div>
    </div>
  );
}

export function DisplayQstnType4({ question, id }) {
  return (
    <div className="border rounded p-2 mt-2">
      <div className="d-flex gap-3">
        <Checkbox id={id} data={question} />
        <label
          className="custom-label-qstn"
          // htmlFor={id}
        >
          Q. {question.question_text}
        </label>
      </div>
    </div>
  );
}

// Comprehensive
export function DisplayQstnType6({ question, id }) {
  return (
    <div className="border rounded p-2 mt-2">
      <div className="d-flex gap-3">
        <Checkbox id={id} data={question} />
        <strong>Comprehension Passage:</strong>
      </div>
      <div className="mx-3">{question.passage_text}</div>
      <span className="mx-3">
        <strong className="mt-2">Questions </strong>
        <ol className="mx-3">
          {question.subQuestions?.map((subQstn, i) => (
            <li key={i + 1}>{subQstn.question_text}</li>
          ))}
        </ol>
      </span>
    </div>
  );
}

// 8 - Answer in one word
export function DisplayQstnType8({ question, id }) {
  return (
    <div className="border rounded p-2 mt-2">
      <div className="d-flex gap-3">
        <Checkbox id={id} data={question} />
        <label
          className="custom-label-qstn"
          // htmlFor={id}
        >
          Q. {question.question_text}
        </label>
      </div>
    </div>
  );
}

// 9 - Define Term
export function DisplayQstnType9({ question, id }) {
  return (
    <div className="border rounded p-2 mt-2">
      <div className="d-flex gap-3">
        <Checkbox id={id} data={question} />
        <label
          className="custom-label-qstn"
          // htmlFor={id}
        >
          Q. {question.question_text}
        </label>
      </div>
    </div>
  );
}

// Match the following
export function DisplayQstnType16({ question, id }) {
  return (
    <div className="border rounded p-2 mt-2">
      <div className="d-flex gap-3">
        <Checkbox id={id} data={question} />
        <label
          className="custom-label-qstn"
          // htmlFor={id}
        >
          Q. {question.question_text}
        </label>
      </div>
      <div className="mx-3">
        <div className="d-flex justify-content-center text-center fw-bold">
          <div style={{ width: "200px" }}>Column 1</div>
          <div style={{ width: "200px" }}>Column 2</div>
        </div>

        {question.matching_options?.map((e, index) => (
          <div
            key={index + 1}
            className="d-flex justify-content-center align-items-center text-center mt-2"
          >
            <div style={{ width: "200px" }}>{e.column1_text}</div>
            <div style={{ width: "200px" }}>{e.column2_text}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
